var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9438 3.75643C22.9344 3.74703 21.0303 5.63022 17.2411 9.41542L14.5824 6.75513L20.2474 1.08674C17.2661 -0.708718 13.4362 -0.248103 10.9528 2.23671C10.0035 3.18601 9.3204 4.36836 8.97192 5.66519C8.62345 6.96202 8.62188 8.32773 8.96737 9.62536L9.02374 9.8353L0.14562 18.7155C-0.04854 18.9097 -0.04854 19.2293 0.14562 19.4236L4.57372 23.8543C4.76788 24.0486 5.0873 24.0486 5.28146 23.8543L14.1533 14.9773L14.3631 15.0337C16.9843 15.7324 19.7996 15.0055 21.7537 13.0502C24.2402 10.5654 24.7006 6.73319 22.9438 3.75643Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/serviceIcon.f0c0e0d62da58be06607d2bd00b9f774.svg";
export { ForwardRef as ReactComponent };